import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

signInExistingAccountStyles.rememberMeCheckbox = {
    css: css`
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

signInExistingAccountStyles.signInButton = {
    mergeCss: true,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
};

signInResetPasswordFormStyles.cancelButton = {
    mergeCss: true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css``,
                    css``,
                    null,
                    css`
                        span {
                            font-size: 12px !important;
                        }
                    `,
                    null,
                ],
                "minMax",
            )}
    `,
};

signInExistingAccountStyles.rememberMeCheckbox = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css``,
                    css``,
                    null,
                    css`
                        label {
                            font-size: 12px !important;
                        }
                    `,
                    null,
                ],
                "minMax",
            )}
    `,
};

signInExistingAccountStyles.rememberMeGridItem = {
    width: [6, 6, 6, 7, 6],
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: [6, 6, 6, 5, 6],
    css: css`
        align-items: center !important;
    `,
};
signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

signInExistingAccountStyles.userNameTextField = {
    cssOverrides: {
        inputSelect: css`
            background: ${COLORS.background.grayShade};
            border-radius: 24px;
            &[aria-invalid="true"] {
                background: ${COLORS.background.grayShade};
                border-radius: 24px;
            }
            &:focus {
                border-radius: 24px;
            }
        `,
        formField: css`
            label {
                font-size: ${TYPOGRAPHY.size.smaller};
            }
        `,
    },
};

signInExistingAccountStyles.passwordTextField = {
    cssOverrides: {
        inputSelect: css`
            background: ${COLORS.background.grayShade};
            border-radius: 24px;
            &[aria-invalid="true"] {
                background: ${COLORS.background.grayShade};
                border-radius: 24px;
            }
            &:focus {
                border-radius: 24px;
            }
        `,
        formField: css`
            label {
                font-size: ${TYPOGRAPHY.size.smaller};
            }
        `,
    },
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h4",
    css: css`
        font-size: ${TYPOGRAPHY.size.xxlarge} !important;
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.bold} !important;
        line-height: 40px !important;
    `,
};
